import { useCMSPageField } from '@/cms/fields'
import { space } from '@sunwebgroup/ui-components'
import { IconCell, ListItem, Typography } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'
import { MostBookedByLabel } from './MostBookedByLabel'
import { ReadMore } from './ReadMore'

const MostBookedByLabelWrapper = styled.div`
  margin-bottom: ${space('primitives_space_8')};
`

const UspsWrapper = styled(ListItem)`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_8')};
`

const Usp = styled.li`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_6')};
`

export default function Description() {
  const usps = useCMSPageField('PDP.usps')
  const descriptionText = useCMSPageField('PDP.description')

  return (
    <>
      <MostBookedByLabelWrapper>
        <MostBookedByLabel />
      </MostBookedByLabelWrapper>
      <UspsWrapper variant="transparent" as="ul">
        {!isEmpty(usps)
        && usps.map(item => (
          <Usp key={item}>
            <IconCell glyph="CheckMarkSmall" verticalAlignment="top" size="sm" />
            <Typography $variant="body-m-regular-tight">{item}</Typography>
          </Usp>
        ),
        )}
      </UspsWrapper>
      {descriptionText && (
        <ReadMore>
          <Typography $variant="body-m-regular-snug" dangerouslySetInnerHTML={{ __html: descriptionText }} />
        </ReadMore>
      )}
    </>
  )
}
